module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "20px",
      "height": "100vh",
      "overflow": "auto"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.promotion)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-183173d1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_fc/Promotions/BuyPromotion.vue
// module id = 1551
// module chunks = 8